// extracted by mini-css-extract-plugin
module.exports = {"container":"chartsPlaceholder_container__3X3x1","placeholderContainer":"chartsPlaceholder_placeholderContainer__265MG","placeholder":"chartsPlaceholder_placeholder__3uq5m"};